<template>
    <div class="f-list-home" v-if="hasHomeData">
        <div class="f-list-home-left">
            <main-module class="f-list-home-main"
                ref="mainModule"
                :topicList="homeData.topicList"
                :tagInfo="homeData.tagInfo"
                :pageInfo="homeData.pageInfo">
            </main-module>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../assets/less/views/home/home.less';
</style>

<script>
import MainModule from './components/MainContent.vue';
import {mapState, mapMutations} from 'vuex';
import {scrollToId} from '@/utils/decorate/scroll';
import {sendLog} from '@/utils/osReport';

export default {
    components: {
        'main-module': MainModule
    },
    data() {
        return {
            errorImg: this.$store.state.home.errorImg
        };
    },
    computed: {
        ...mapState({
            // 主页数据
            homeData: state => state.home.homeData,
            // 最大标题长度
            maxTitleWidth: state => state.home.maxTitleWidth,
            activeTag: state => state.home.activeTag,
            activeSort: state => state.home.activeSort
        }),
        hasHomeData() {
            return Object.keys(this.homeData).length;
        }
    },
    mounted() {
        // 获取 params 和 query 初始化并加载数据
        const {params, query} = this.initWeb();
        this.initActive(params, query);
        this.$store.dispatch('getHomeInfo', {params, query});
        sendLog({
            eventName: '首页展现',
            eventCode: 'home_page_show',
            eventType: 1,
            clickName: ''
        });
    },
    destroyed() {
        this.$store.commit('clearHomeData');
    },
    methods: {
        ...mapMutations([
            'changeActiveTag',
            'changeActiveSort'
        ]),
        initActive(params, query) {
            let tag = query.tagId ? +query.tagId : 0;
            this.changeActiveTag(tag);
        },
        initWeb() {
            const params = this.$route.params;
            const query = this.$route.query;
            return {params, query};
        },
        watchHandler(to, from) {
            this.$store.commit('changeLoadingState', true);
            this.$store.dispatch('getMainList', {params: to.params, query: to.query})
                .then(() => {
                    if (to.query.pageNo && to.query.pageNo !== from.query.pageNo) {
                        scrollToId('homeTab');
                    }
                    this.$store.commit('changeLoadingState', false);
                });
        }
    }
};
</script>
